/* eslint-disable no-alert */
/* eslint-disable no-console */
import { AxiosError } from 'axios';

import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import {
  applyTicket,
  // checkTicketingOpen,
  // getTicketingInfo,
} from 'src/apis/utils/ticket/ticket';
import {
  BoardSetWidth,
  Wrapper,
} from 'src/styles/user-mobile/OverviewStyleMobile';
import { TICKETING_ID } from 'src/assets/database/ticketData';
import TicketTitleArea from './molcules/TicketTitleArea';
import TicketInputField from './molcules/TicketInputField';
import TermsAndConditions from './molcules/TermsAndConditions';
import NumberofTickets from './molcules/NumberofTickets';

import ReserveNoTime from './modal/ReserveNoTime';
import TicketComplete from './modal/TicketComplete';
import TicketDuplication from './modal/TicketDuplication';
import TicketingNotice from './modal/TicketingNotice';
import TicketSoldOut from './modal/TicketSoldOut';
import PersonalInfoUse from './modal/PersonalInfoUse';
import CodeSentModal from './modal/CodeSentModal';
import CodeSendFailedModal from './modal/CodeSendFailedModal';

import NotConfirmed from './modal/NotConfirmed';
import TelConfirmed from './modal/TelConfirmed';

export default function TicketAuth() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [TicketCount, setTicketCount] = useState(1);
  const [noticeChecked, setNoticeChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState<string | null>(null);

  const openModal = (modalName: string) => {
    setCurrentModal(modalName);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentModal(null);
  };

  const handleApplyTicket = async () => {
    try {
      await applyTicket({
        eventId: TICKETING_ID,
        phoneNumber,
        ticketCount: TicketCount,
      });
      openModal('TicketComplete');
    } catch (err) {
      const error = err as AxiosError<{
        code: string;
        message: string;
        status: number;
      }>;

      // 에러는 임의로 처리해둠
      console.error('티켓 신청 실패', error);
      const errorCode = error?.response?.data?.code;
      if (errorCode === 'T002') {
        // 이미 신청한 전화번호
        openModal('TicketDuplication');
      } else if (errorCode === 'T003') {
        // 티켓 매진 - 확정 아님
        openModal('TicketSoldOut');
      } else {
        alert('알 수 없는 오류가 발생했습니다.');
      }
    }
  };

  useEffect(() => {
    // openModal('TestPage');
    // // 티켓팅 오픈 여부 체크
    // checkTicketingOpen(TICKETING_ID)
    //   .then(() => {}) // response 없이 200이면 모달X -> 티켓팅 가능
    //   .catch(error => {
    //     if (error.response?.status === 400) openModal('ReserveNoTime');
    //     // 400오류면 오픈X -> 모달 띄우기
    //     else alert(error);
    //   });

    // // 티켓팅 정보 조회
    // getTicketingInfo(TICKETING_ID)
    //   .then(response => {
    //     if (response.data?.remainingTickets <= 0) openModal('TicketSoldOut');
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    openModal('TicketSoldOut');
  }, []);

  const renderModal = () => {
    if (!modalOpen) return null;

    switch (currentModal) {
      case 'ReserveNoTime':
        return <ReserveNoTime onClose={closeModal} />;
      case 'TicketComplete':
        return <TicketComplete onClose={closeModal} />;
      case 'TicketDuplication':
        return <TicketDuplication onClose={closeModal} />;
      case 'TicketingNotice':
        return <TicketingNotice onClose={closeModal} />;
      case 'TicketSoldOut':
        return <TicketSoldOut onClose={closeModal} />;
      case 'PersonalInfoUse':
        return <PersonalInfoUse onClose={closeModal} />;
      case 'NotConfirmed':
        return <NotConfirmed onClose={closeModal} />;
      case 'TelConfirmed':
        return <TelConfirmed onClose={closeModal} />;
      case 'CodeSent':
        return <CodeSentModal onClose={closeModal} />;
      case 'CodeSendFailed':
        return <CodeSendFailedModal onClose={closeModal} />;
      default:
        return null;
    }
  };

  const isButtonActive = isVerified && noticeChecked && privacyChecked;

  return (
    <Wrapper>
      <BoardSetWidth>
        <TicketTitleArea />
        <TicketInputField
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          isVerified={isVerified}
          setIsVerified={setIsVerified}
          openModal={openModal}
        />{' '}
        <NumberofTickets count={TicketCount} setCount={setTicketCount} />
        <TermsAndConditions
          noticeChecked={noticeChecked}
          setNoticeChecked={setNoticeChecked}
          privacyChecked={privacyChecked}
          setPrivacyChecked={setPrivacyChecked}
        />
        <TicketAuthButton
          type="button"
          disabled={!isButtonActive}
          onClick={handleApplyTicket}
        >
          입장권 예매하기
        </TicketAuthButton>
        {renderModal()}
      </BoardSetWidth>
    </Wrapper>
  );
}

const TicketAuthButton = styled.button<{ disabled?: boolean }>`
  margin: 20px auto 0;
  display: flex;
  padding: 13px 89px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: ${({ disabled }) => (disabled ? '#B5BED9' : '#0b2873')};

  color: #fff;
  text-align: center;
  font-family: 'GmarketSansBold';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.45px;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
